import { Component, OnInit } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { MgService } from 'src/app/services/mg.service';
import { Pagination } from 'src/app/models/pagination.model';
import { PageEvent } from '@angular/material/paginator';
import { OpenCallDialogComponent } from 'src/app/components/user/open-call-dialog/open-call-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-client-call-list',
  templateUrl: './client-call-list.component.html',
  styleUrls: ['./client-call-list.component.scss']
})
export class ClientCallListComponent implements OnInit {
  public page: Pagination;
  public calls: Call[];
  public isLoading: boolean = false;

  public pageSize = 0;
  public length = 0;
  public pageSizeOptions: number[] = [20, 35, 50, 100];
  public pageEvent: PageEvent;

  constructor(
    private api: MgService,
  ) { }

  ngOnInit(): void {
    this.listCalls();
  }

  public set setPage(page: PageEvent) {
    this.pageEvent = page;
    this.listCalls(page.pageIndex + 1, page.pageSize);
  }

  private listCalls(page: number = 1, perPage: number = 20): void {
    this.isLoading = true;
    this.api.listBusinessUserCalls(page, perPage)
      .subscribe(
        res => {
          this.page = res;
          this.calls = this.page.data;
          this.length = this.page.meta.total
          this.pageSize = this.page.meta.per_page
        },
        err => {
          console.error(err);
          this.isLoading = false;
        },
        () => this.isLoading = false,
      )
  }
}
